'use strict';

/**
 * Initializes Slick sliders for elements with the class `plp-images`.
 *
 */
function plpImageSlickInit() {
    $('.plp-images').each(function () {
        var $this = $(this);
        if (!$this.hasClass('slick-initialized')) {
            $this.slick({
                dots: true,
                lazyLoad: 'ondemand',
                arrows: true,
                infinite: false,
                speed: 500,
                touchThreshold: 100,
                slidesToShow: 1,
                slidesToScroll: 1,
                nextArrow: '<button type="button" class="slick-next"><i class="icon icon-arrow-right-icon"></i></button>',
                prevArrow: '<button type="button" class="slick-prev"><i class="icon icon-arrow-left-icon"></i></button>',
            });
            $this.mouseenter(function () {
                var currentSlide = $this.slick('slickCurrentSlide');
                if (currentSlide === 0) {
                    $this.slick('slickNext');
                }
            });
            $this.mouseleave(function () {
                $this.slick('slickGoTo', 0);
            });
        }
    });
}

$(document).ready(function () {
    plpImageSlickInit();
    $('body').on('search:updateDom', plpImageSlickInit);
    $(document).on('click', '.plp-images .slick-arrow', function (e) {
        e.preventDefault();
    });
});
